<template>
  <div>
    <wc-data-box
      :title='storePath.title'
      :titleIcon='storePath.icon'
      :titleIconColor='storePath.iconColor'
      showEdit
      @edit='openEdit'
    >
      <v-simple-table dense>
        <tbody>
          <tr>
            <td :class='label'>Name</td>
            <td :class='dataValue'>{{ item.name }}</td>
          </tr>
          <tr>
            <td :class='label'>Year</td>
            <td :class='dataValue'>{{ item.year }}</td>
          </tr>
          <tr>
            <td :class='label'>Make</td>
            <td :class='dataValue'>{{ item.make }}</td>
          </tr>
          <tr>
            <td :class='label'>Model</td>
            <td :class='dataValue'>{{ item.model }}</td>
          </tr>
          <tr>
            <td :class='label'>Color</td>
            <td :class='dataValue'>{{ item.color }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>
  <!-- edit dialog box below  -->
    <wc-dialog
      :showDialog='showDialog'
      title='Edit Basics'
      :icon='storePath.icon'
      :iconColor='storePath.iconColor'
      width='400'
      @cancel='cancelEdit'
      @save='saveEdit'
      :loading='isLoading'
    >
      <v-form ref='form'>
        <v-text-field
          label='Name'
          :rules='[rules.required]'
          v-model='itemCopy.name'
        ></v-text-field>
        <v-row>
          <v-col cols='12' sm='6'>
            <v-text-field
              label='Year'
              v-model='itemCopy.year'
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='6'>
            <v-text-field
              label='Make'
              v-model='itemCopy.make'
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='12' sm='6'>
            <v-text-field
              label='Model'
              v-model='itemCopy.model'
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='6'>
            <v-text-field
              label='Color'
              v-model='itemCopy.color'
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'
export default {
  name: 'vehicle-basics',
  props: {
    item: {
      required: true
    }
  },
  mixins: [formRules],
  data: () => ({
    label: 'grey--text',
    dataValue: 'text-right',
    showDialog: false,
    isLoading: false,
    itemCopy: {}
  }),
  computed:{
    storePath () { return this.$store.state.icons.dataBox.basics }
  },
  methods: {
    openEdit () {
      this.itemCopy = _.cloneDeep(this.item)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      this.isLoading = true
      this.$emit('update', this.itemCopy)
      this.cancelEdit()
      this.isLoading = false
    }
  }
}
</script>